import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { invoiceService } from '../services/api';
import './InvoiceList.css';

function InvoiceList({ user }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    try {
      const response = await invoiceService.listInvoices();
      setInvoices(response.invoices);
    } catch (err) {
      setError('Error al cargar facturas');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      sin_validar: { label: 'Sin Validar AFIP', class: 'badge-sin-validar' },
      Pendiente: { label: 'Pendiente de Aprobación', class: 'badge-pending' },
      draft: { label: 'Borrador', class: 'badge-draft' },
      pending_approval: { label: 'Pendiente', class: 'badge-pending' },
      approved: { label: 'Aprobada', class: 'badge-approved' },
      rejected: { label: 'Rechazada', class: 'badge-rejected' },
      posted: { label: 'Enviada', class: 'badge-posted' },
      failed: { label: 'Error', class: 'badge-rejected' }
    };
    
    const statusInfo = statusMap[status] || { label: status, class: 'badge-draft' };
    return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleDateString('es-AR');
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(amount);
  };

  if (loading) {
    return <div className="container loading">Cargando facturas...</div>;
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1>Facturas</h1>
        {user?.canCreateInvoices && (
          <Link to="/invoices/new" className="btn btn-primary">
            Nueva Factura
          </Link>
        )}
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {invoices.length === 0 ? (
        <div className="card">
          <p style={{ textAlign: 'center', color: '#666' }}>
            No hay facturas registradas.
            {user?.canCreateInvoices && (
              <>
                {' '}
                <Link to="/invoices/new">Crea la primera factura</Link>
              </>
            )}
          </p>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Nº Factura</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Monto</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice.invoiceId}>
                  <td>
                    {invoice.tipoComprobante}-{invoice.puntoVenta}-{invoice.invoiceNumber}
                  </td>
                  <td>{invoice.supplierName || 'Sin especificar'}</td>
                  <td>{invoice.invoiceDate || formatDate(invoice.createdAt)}</td>
                  <td>{formatAmount(invoice.totalAmount)}</td>
                  <td>{getStatusBadge(invoice.status)}</td>
                  <td>
                    <Link 
                      to={`/invoices/${invoice.invoiceId}`} 
                      className="btn btn-secondary btn-sm"
                    >
                      Ver Detalle
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default InvoiceList;
